<template>
	<div class="divcreateorder">
		<customer_detail_default ref="default" :urlparam="pageparam" :id="id" :updatetime="updatetime" :handle="handle"></customer_detail_default>
	</div>
</template>
<script>
import customer_detail_default from '@/components/crm/customer_detail_default.vue';	
export default {
	components: {
		customer_detail_default
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			pageparam:{},
			id:'',
			type:'',
			updatetime:'',
			handle:'0'
		}
	},
	mounted() {
		var that=this;
		if (this.urlparam!= undefined) {
			this.pageparam=this.urlparam;
			if (this.urlparam.id != undefined) {
				this.id = this.urlparam.id;
			}
			if (this.urlparam.updatetime != undefined) {
				this.updatetime = this.urlparam.updatetime;
			}
			if (this.urlparam.handle != undefined) {
				this.handle = this.urlparam.handle;
			}
		}
		this.$nextTick(function() {
			if(that.$refs.default!=undefined)
				that.$refs.default.init();
		});
	}
}
</script>